import OpeningHours from "./openingHours";
export default OpeningHours